import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { Card } from '../components/ui/card';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';
import { faqs } from '../data/mockData';

const FAQ = () => {
  const { language } = useLanguage();

  const content = {
    en: {
      title: 'Frequently Asked Questions',
      subtitle: 'Find answers to common questions about our products, services, and processes'
    },
    vi: {
      title: 'Câu hỏi thường gặp',
      subtitle: 'Tìm câu trả lời cho các câu hỏi phổ biến về sản phẩm, dịch vụ và quy trình của chúng tôi'
    }
  };

  const t = content[language];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <section className="bg-gradient-to-r from-[#264f78] to-[#1a3a57] text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">{t.title}</h1>
            <p className="text-lg text-white/90">{t.subtitle}</p>
          </div>
        </div>
      </section>

      {/* FAQ Sections */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-8">
            {faqs.map((section, sectionIndex) => (
              <Card key={sectionIndex} className="p-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-6">{section.category}</h2>
                <Accordion type="single" collapsible className="space-y-4">
                  {section.questions.map((faq, faqIndex) => (
                    <AccordionItem key={faqIndex} value={`item-${sectionIndex}-${faqIndex}`} className="border-b border-gray-200 last:border-0">
                      <AccordionTrigger className="text-left hover:text-[#264f78] transition-colors duration-200">
                        <span className="font-semibold text-gray-900">{faq.q}</span>
                      </AccordionTrigger>
                      <AccordionContent>
                        <p className="text-gray-600 leading-relaxed pt-2">{faq.a}</p>
                      </AccordionContent>
                    </AccordionItem>
                  ))}
                </Accordion>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
            {language === 'en' ? 'Still Have Questions?' : 'Vẫn còn câu hỏi?'}
          </h2>
          <p className="text-lg text-gray-600 mb-8">
            {language === 'en'
              ? 'Our team is here to help. Contact us for any additional questions or specific inquiries.'
              : 'Nhóm của chúng tôi sẵn sàng giúp đỡ. Liên hệ với chúng tôi cho bất kỳ câu hỏi bổ sung hoặc yêu cầu cụ thể.'}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/contact"
              className="inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-[#264f78] hover:bg-[#1a3a57] transition-all duration-300"
            >
              {language === 'en' ? 'Contact Us' : 'Liên hệ'}
            </a>
            <a
              href="/request-quote"
              className="inline-flex items-center justify-center px-8 py-3 border-2 border-[#264f78] text-base font-medium rounded-md text-[#264f78] bg-white hover:bg-[#264f78] hover:text-white transition-all duration-300"
            >
              {language === 'en' ? 'Request Quote' : 'Yêu cầu báo giá'}
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
